<template>
  <div class="BilgiKutu" v-if="data">
    <h1>{{ data.Baslik }}</h1>
    <ul class="BilgiKutuUl">
      <li v-for="(activity, index) in data.Detay" v-if="activity.Bilgi">
        <small class="d-block">{{ activity.Baslik }}</small>
        <span v-html="activity.Bilgi"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/BilgiKutu.vue